"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "carpineto-della-nora": {
    "16c2dbfe": [{
      "hkey": "4ca06524",
      "slug": "carpineto-della-nora",
      "name": "Carpineto della Nora",
      "primary": true,
      "skipSearch": false
    }],
    "san-bartolomeo": [{
      "hkey": "4ca06524",
      "slug": "carpineto-della-nora",
      "name": "Carpineto della Nora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;